<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="555.911"
    height="341.918"
    viewBox="0 0 555.911 341.918"
  >
    <g
      id="Illustration_partenaire"
      transform="translate(-1048.045 -2530.032)"
    >
      <g id="Feuille">
        <path
          id="Feuille_droite"
          class="primaire"
          d="M188.636 756.216c4.425 8.206 13.816 11.729 13.816 11.729s2.217-9.782-2.208-17.988-13.816-11.729-13.816-11.729-2.217 9.782 2.208 17.988z"
          transform="translate(1006.684 2084.891)"
        />
        <path
          id="Feuille_gauche"
          class="secondaire"
          d="M169.865 775.084c7.989 4.806 11.066 14.353 11.066 14.353s-9.876 1.754-17.865-3.052S152 772.032 152 772.032s9.876-1.755 17.865 3.052z"
          transform="translate(1028.496 2063.324)"
        />
      </g>
      <path
        id="Fond"
        class="background"
        d="M566.981 307.374a113.921 113.921 0 0 1-3.337 27.488q-1.123 4.545-2.61 8.9a105.147 105.147 0 0 1-4.21 10.534q-1.2 2.605-2.544 5.107a68.7 68.7 0 0 1-5.744 27.606A71.169 71.169 0 0 1 514 422.6a72.652 72.652 0 0 1-30.834 7.08H116.608a92.355 92.355 0 0 1-46.451-12.42l-.217-.123q-3.016-1.765-5.881-3.738a92.231 92.231 0 0 1-12.069-9.949 89.808 89.808 0 0 1-13.267-16.439 87.721 87.721 0 0 1-13.494-46.834 110.446 110.446 0 0 1-14.159-54.693c0-25.487 8.288-48.736 21.9-66.336a93.26 93.26 0 0 1 9.3-10.35 86.568 86.568 0 0 1 10.638-8.708 82.767 82.767 0 0 1 9.44-5.664 78.3 78.3 0 0 1 4.125-1.959 74.431 74.431 0 0 1 3.71-1.525q2.251-.854 4.559-1.572t4.555-1.255q3.3-.807 6.721-1.312a82.488 82.488 0 0 1 5.664-.618c1.5-.113 3.016-.175 4.54-.194h.826c1.68 0 3.351.066 5.008.179.175-.349.363-.7.538-1.048a149.89 149.89 0 0 1 2.034-3.743.118.118 0 0 1 0-.033c.118-.217.236-.43.359-.637.557-1.005 1.137-2 1.732-2.988.274-.472.543-.916.821-1.359a3.609 3.609 0 0 1 .193-.321q.425-.708.864-1.416 2.185-3.493 4.545-6.863l.4-.576c.245-.349.472-.689.746-1.038.651-.911 1.322-1.827 2-2.723.472-.642.944-1.279 1.454-1.888q1.841-2.36 3.776-4.72t4.021-4.658c.189-.212.378-.42.576-.628l2.015-2.2c.1-.1.184-.2.278-.293.241-.26.472-.519.732-.769a185.03 185.03 0 0 1 3.3-3.389 179.915 179.915 0 0 1 18.077-15.75c.25-.2.505-.387.755-.576 1.2-.9 2.417-1.794 3.634-2.671a191.29 191.29 0 0 1 20.96-13.074c.5-.288 1.01-.557 1.524-.821a200.119 200.119 0 0 1 20.054-9.232 210.761 210.761 0 0 1 11.393-4.134c2.558-.84 5.126-1.638 7.726-2.388q6.1-1.756 12.281-3.148a218.688 218.688 0 0 1 36.927-5.031q5.664-.288 11.455-.3a219.471 219.471 0 0 1 55.221 6.985 1.992 1.992 0 0 0 1.713.892h1.586c.689.189 1.373.378 2.063.576q5.772 1.661 11.379 3.629l.944.34a203.156 203.156 0 0 1 26.86 11.8 193.832 193.832 0 0 1 22.49 13.895q1.657 1.189 3.266 2.4 1.954-1.251 3.974-2.4a78.166 78.166 0 0 1 16.462-7.018 75.092 75.092 0 0 1 36.927-1.444c15.693 3.327 29.9 11.587 41.373 23.334A96.546 96.546 0 0 1 513.9 156.5c.26.406.519.817.769 1.232a103.832 103.832 0 0 1 7.9 15.75c.08.2.16.392.231.59a109.051 109.051 0 0 1 4.861 15.74c.057.274.123.543.179.817a113.329 113.329 0 0 1 2.322 15.75 3.048 3.048 0 0 0 .038.581q.3 4.111.3 8.307c0 2.5-.085 4.984-.241 7.448 0 .269-.038.547-.061.826-.042.713-.1 1.416-.165 2.133a89.565 89.565 0 0 1 10.091 9.52q2.063 2.251 3.993 4.673a99.4 99.4 0 0 1 10.289 15.75 110.528 110.528 0 0 1 12.575 51.757z"
        transform="translate(1036.975 2442.272)"
      />
      <path
        id="Sol"
        class="cls-4"
        transform="translate(1180.496 2852.346)"
        d="M0 0h319.007v.814H0z"
      />
      <g id="Mur">
        <path
          id="Rectangle_1292"
          data-name="Rectangle 1292"
          class="cls-4"
          transform="translate(1327.627 2600.133)"
          d="M0 0h49.845v.712H0z"
        />
        <path
          id="Rectangle_1293"
          data-name="Rectangle 1293"
          class="cls-4"
          transform="translate(1363.23 2600.666)"
          d="M0 0h.712v6.587H0z"
        />
        <path
          id="Rectangle_1294"
          data-name="Rectangle 1294"
          class="cls-4"
          transform="translate(1341.512 2600.666)"
          d="M0 0h.712v6.587H0z"
        />
        <path
          id="Rectangle_1295"
          data-name="Rectangle 1295"
          class="cls-4"
          transform="translate(1352.906 2634.312)"
          d="M0 0h49.845v.712H0z"
        />
        <path
          id="Rectangle_1296"
          data-name="Rectangle 1296"
          class="cls-4"
          transform="translate(1366.436 2627.903)"
          d="M0 0h.712v6.587H0z"
        />
        <path
          id="Rectangle_1297"
          data-name="Rectangle 1297"
          class="cls-4"
          transform="translate(1388.152 2627.903)"
          d="M0 0h.712v6.587H0z"
        />
        <path
          id="Rectangle_1298"
          data-name="Rectangle 1298"
          class="cls-4"
          transform="translate(1419.129 2650.334)"
          d="M0 0h49.845v.712H0z"
        />
        <path
          id="Rectangle_1299"
          data-name="Rectangle 1299"
          class="cls-4"
          transform="translate(1432.658 2643.925)"
          d="M0 0h.712v6.587H0z"
        />
        <path
          id="Rectangle_1300"
          data-name="Rectangle 1300"
          class="cls-4"
          transform="translate(1454.375 2643.925)"
          d="M0 0h.712v6.587H0z"
        />
        <path
          id="Rectangle_1301"
          data-name="Rectangle 1301"
          class="cls-4"
          transform="translate(1414.145 2815.533)"
          d="M0 0h49.845v.712H0z"
        />
        <path
          id="Rectangle_1302"
          data-name="Rectangle 1302"
          class="cls-4"
          transform="translate(1427.674 2809.125)"
          d="M0 0h.712v6.587H0z"
        />
        <path
          id="Rectangle_1303"
          data-name="Rectangle 1303"
          class="cls-4"
          transform="translate(1449.391 2809.125)"
          d="M0 0h.712v6.587H0z"
        />
        <path
          id="Rectangle_1304"
          data-name="Rectangle 1304"
          class="cls-4"
          transform="translate(1329.051 2701.246)"
          d="M0 0h49.845v.712H0z"
        />
        <path
          id="Rectangle_1305"
          data-name="Rectangle 1305"
          class="cls-4"
          transform="translate(1342.58 2694.838)"
          d="M0 0h.712v6.587H0z"
        />
        <path
          id="Rectangle_1306"
          data-name="Rectangle 1306"
          class="cls-4"
          transform="translate(1364.299 2694.838)"
          d="M0 0h.712v6.587H0z"
        />
        <path
          id="Rectangle_1310"
          data-name="Rectangle 1310"
          class="cls-4"
          transform="translate(1424.469 2761.061)"
          d="M0 0h49.845v.712H0z"
        />
        <path
          id="Rectangle_1311"
          data-name="Rectangle 1311"
          class="cls-4"
          transform="translate(1437.998 2754.651)"
          d="M0 0h.712v6.587H0z"
        />
        <path
          id="Rectangle_1312"
          data-name="Rectangle 1312"
          class="cls-4"
          transform="translate(1459.717 2754.651)"
          d="M0 0h.712v6.587H0z"
        />
        <circle
          id="Ellipse_249"
          data-name="Ellipse 249"
          class="cls-4"
          cx="3.942"
          cy="3.942"
          r="3.942"
          transform="translate(1369.143 2706.648)"
        />
        <path
          id="Rectangle_1319"
          data-name="Rectangle 1319"
          class="cls-4"
          transform="translate(1201.947 2712.995)"
          d="M0 0h49.845v.712H0z"
        />
        <path
          id="Rectangle_1320"
          data-name="Rectangle 1320"
          class="cls-4"
          transform="translate(1215.477 2706.587)"
          d="M0 0h.712v6.587H0z"
        />
        <path
          id="Rectangle_1321"
          data-name="Rectangle 1321"
          class="cls-4"
          transform="translate(1237.195 2706.587)"
          d="M0 0h.712v6.587H0z"
        />
        <path
          id="Rectangle_1322"
          data-name="Rectangle 1322"
          class="cls-4"
          transform="translate(1219.393 2607.609)"
          d="M0 0h49.845v.712H0z"
        />
        <path
          id="Rectangle_1323"
          data-name="Rectangle 1323"
          class="cls-4"
          transform="translate(1254.996 2608.144)"
          d="M0 0h.712v6.587H0z"
        />
        <path
          id="Rectangle_1324"
          data-name="Rectangle 1324"
          class="cls-4"
          transform="translate(1233.277 2608.144)"
          d="M0 0h.712v6.587H0z"
        />
        <path
          id="Rectangle_1325"
          data-name="Rectangle 1325"
          class="cls-4"
          transform="translate(1269.594 2677.748)"
          d="M0 0h49.845v.712H0z"
        />
        <path
          id="Rectangle_1326"
          data-name="Rectangle 1326"
          class="cls-4"
          transform="translate(1305.197 2678.282)"
          d="M0 0h.712v6.587H0z"
        />
        <path
          id="Rectangle_1327"
          data-name="Rectangle 1327"
          class="cls-4"
          transform="translate(1283.479 2678.282)"
          d="M0 0h.712v6.587H0z"
        />
        <path
          id="Rectangle_1328"
          data-name="Rectangle 1328"
          class="cls-4"
          transform="translate(1184.857 2677.393)"
          d="M0 0h49.845v.712H0z"
        />
        <path
          id="Rectangle_1329"
          data-name="Rectangle 1329"
          class="cls-4"
          transform="translate(1220.461 2677.926)"
          d="M0 0h.712v6.587H0z"
        />
        <path
          id="Rectangle_1330"
          data-name="Rectangle 1330"
          class="cls-4"
          transform="translate(1198.742 2677.926)"
          d="M0 0h.712v6.587H0z"
        />
        <path
          id="Rectangle_1331"
          data-name="Rectangle 1331"
          class="cls-4"
          transform="translate(1244.672 2641.789)"
          d="M0 0h49.845v.712H0z"
        />
        <path
          id="Rectangle_1332"
          data-name="Rectangle 1332"
          class="cls-4"
          transform="translate(1258.201 2635.38)"
          d="M0 0h.712v6.587H0z"
        />
        <path
          id="Rectangle_1333"
          data-name="Rectangle 1333"
          class="cls-4"
          transform="translate(1279.918 2635.38)"
          d="M0 0h.712v6.587H0z"
        />
      </g>
      <g id="Personnage">
        <path
          id="Cou"
          class="skin"
          d="M747.411 136.058s5.2 14.813 2 17.092 10.81 20.89 10.81 20.89l16.815-4.558-9.208-15.573s-1.2-15.573-1.2-17.852-19.217.001-19.217.001z"
          transform="translate(645.072 2473.32)"
        />
        <path
          id="Cou_ombre"
          d="M747.411 136.058s5.2 14.813 2 17.092 10.81 20.89 10.81 20.89l16.815-4.558-9.208-15.573s-1.2-15.573-1.2-17.852-19.217.001-19.217.001z"
          transform="translate(645.072 2473.32)"
          style="opacity: 0.1;"
        />
        <path
          id="Chaussure_gauche"
          class="primaire"
          d="M755.783 758.784v6.077s-6.837 16.52 0 16.52 12.154 1.712 12.154-.567V760.3z"
          transform="translate(641.637 2071.654)"
        />
        <path
          id="Pantalon"
          class="secondaire"
          d="M721.652 414.2s-1.519 18.991 0 28.867 3.8 37.223 3.8 37.223 0 51.657 8.356 52.416 14.432 1.523 15.192-1.516-3.8-4.558-1.519-6.077 3.039-6.837 0-12.914 0-67.609 0-67.609l14.433 38.742s1.519 31.905 3.039 36.463-1.519 12.914 3.8 13.674 11.395-3.8 14.433-5.318-4.558-1.519-3.039-2.279 6.077-3.039 4.558-3.8-3.039-37.223-3.039-37.223-4.178-77.865-9.5-80.9-8.736 2.2-8.736 2.2z"
          transform="translate(662.096 2300.767)"
        />
        <path
          id="Chaussure_droite"
          class="primaire"
          d="M865.181 758.754v6.077s6.837 16.52 0 16.52-12.154 1.712-12.154-.567v-20.511z"
          transform="translate(577.061 2071.674)"
        />
        <circle
          id="Tete"
          class="skin"
          cx="13.674"
          cy="13.674"
          r="13.674"
          transform="translate(1389.445 2593.046)"
        />
        <path
          id="Tee_shirt"
          d="M762.8 201.9s3.8 11.395 9.876 9.116l6.077-2.279 10.635 72.927s-8.356 12.154-20.511 4.558S762.8 201.9 762.8 201.9z"
          transform="translate(636.141 2430.268)"
          style="fill: #fff;"
        />
        <path
          id="Veste_droite"
          class="primaire"
          d="m795.418 182.446 3.418-7.217s20.131 9.5 23.169 12.534a11.864 11.864 0 0 1 3.039 7.6l-5.318 18.991s1.519 41.781 1.519 43.3 5.318 9.876 1.519 6.837-4.558-6.077-7.6-1.519-9.875 9.876-9.875 9.876z"
          transform="translate(614.158 2447.443)"
        />
        <path
          id="Cheveux"
          class="hair"
          d="M749.407 76.061c-3.031-.108-6.275-.162-8.831 1.472a12.927 12.927 0 0 0-3.052 2.988c-2.489 3.147-4.64 7.106-3.715 11.01l1.074-.419a7.032 7.032 0 0 1-.678 3.013c.151-.44.658.271.522.716l-1.183 3.881a3.654 3.654 0 0 1 4.66 2.781c.135-4.508.6-9.677 4.26-12.316 1.844-1.331 4.178-1.737 6.423-2.1 2.071-.333 4.243-.65 6.227.032s3.674 2.711 3.224 4.761a2.121 2.121 0 0 1 2.39 1.178 6.188 6.188 0 0 1 .489 2.832c.975.689 2.085-.679 2.483-1.805.933-2.643 1.762-5.457 1.26-8.215s-2.75-5.393-5.553-5.4a1.946 1.946 0 0 0 .506-1.37l-2.31-.2a2.554 2.554 0 0 0 1.526-.8c-.929 1.018-8.222-1.986-9.722-2.039z"
          transform="translate(654.004 2511.334)"
        />
        <path
          id="Veste_Gauche"
          class="primaire"
          d="M719.839 178.779s-6.184-6.06-8.41-5.689-5.264 5.689-5.264 5.689-18.232 6.077-17.472 12.154 9.116 35.7 9.116 35.7 6.837 35.7.76 39.5 28.867 13.674 29.626 9.116 2.279-50.137 0-56.974-8.356-39.496-8.356-39.496z"
          transform="translate(682.898 2448.831)"
        />
        <path
          id="Manche_droite"
          class="primaire"
          d="M850.893 223.236h9.393s6.56 28.867 7.319 31.905 2.279 17.472 1.519 17.472-15.953-3.039-15.953-.76z"
          transform="translate(578.434 2416.527)"
        />
        <path
          id="Feuille-2"
          data-name="Feuille"
          style="fill: #fff;"
          d="M780 339.655h-35.961c-3.509-16.143-3.8-31.739 0-46.641H780c-5.8 14.634-6.167 30.123 0 46.641z"
          transform="translate(649.01 2371.594)"
        />
        <path
          id="Mains_gauche"
          class="skin"
          d="m707.938 356.127 10.635 4.558s20.511 3.039 20.511-5.318-20.511-3.8-20.511-3.8l-6.837-2.186z"
          transform="translate(670.492 2335.294)"
        />
        <path
          id="Manche_guache"
          class="primaire"
          d="m684.259 210.435-9.116 2.279-6.837 40.262s-2.279 10.635 1.519 11.395 14.433 6.837 14.433 6.837 1.519-11.395 4.558-11.395l-7.6-6.077 4.558-26.588z"
          transform="translate(696.449 2424.771)"
        />
        <path
          id="Bras_droit"
          class="skin"
          d="m845.941 349.122-2.279 21.27s-13.674 12.154-10.635 12.914 4.558-2.279 4.558-2.279 5.318 5.318 8.356 2.279 10.635-31.906 10.635-31.906z"
          transform="translate(590.223 2335.462)"
        />
      </g>
      <g id="Cadi">
        <path
          id="Contenu"
          class="secondaire"
          d="M183.5 472.452h-83.231L82.26 413.015h119.785l-.109.35z"
          transform="translate(1129.191 2321.381)"
        />
        <g
          id="Cadi-2"
          data-name="Cadi"
        >
          <path
            id="Tracé_2761"
            data-name="Tracé 2761"
            class="cls-9"
            d="m1203.51 2730.6 20.334 66.27h94.219l21.17-66.28z"
          />
          <path
            id="Tracé_2762"
            data-name="Tracé 2762"
            class="cls-9"
            d="m1229.516 2799.341 2.611 7.573 81.08.036v28h-80.189"
            transform="translate(-3.951 1.898)"
          />
          <path
            id="Tracé_2763"
            data-name="Tracé 2763"
            class="cls-9"
            d="m1340.891 2723.734 4.242-14.516h22.344"
          />
          <path
            id="Tracé_2764"
            data-name="Tracé 2764"
            class="cls-10"
            d="M1209.9 2750.956h122.768"
          />
          <path
            id="Tracé_2765"
            data-name="Tracé 2765"
            class="cls-10"
            d="M1216.619 2773.015h108.787"
          />
          <path
            id="Tracé_2766"
            data-name="Tracé 2766"
            class="cls-10"
            d="m1243.385 2730.593 4.607 66.421"
          />
          <path
            id="Tracé_2767"
            data-name="Tracé 2767"
            class="cls-10"
            d="M1271.371 2730.593v66.31"
          />
          <path
            id="Tracé_2768"
            data-name="Tracé 2768"
            class="cls-10"
            d="m1299.09 2730.593-4.4 66.34"
          />
        </g>
        <circle
          id="Roue_gauche"
          class="primaire"
          cx="6.368"
          cy="6.368"
          r="6.368"
          transform="translate(1229.951 2839.473)"
        />
        <circle
          id="Roue_Droite"
          class="primaire"
          cx="6.368"
          cy="6.368"
          r="6.368"
          transform="translate(1292.723 2839.473)"
        />
        <circle
          id="Poigné"
          class="primaire"
          cx="3.942"
          cy="3.942"
          r="3.942"
          transform="translate(1369.143 2706.648)"
        />
      </g>
    </g>
  </svg>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class SvgHomePartnerPictoShopping extends Vue {}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/general';
.background {
  fill: var(--v-stickers_secondaire-base);
  opacity: 0.1;
}
.primaire {
  fill: var(--v-stickers_primaire-base);
}
.secondaire {
  fill: var(--v-stickers_secondaire-base);
}
.skin {
  fill: #d0a0a7;
}
.hair {
  fill: #000000;
}
.cls-10,
.cls-9,
.cls-4 {
  fill: none;
  stroke: #fff;
  stroke-linecap: round;
  stroke-width: 2px;
}
.cls-9 {
  stroke-linejoin: round;
}
</style>
